import { gql } from '@/lib/graphql/gql'

export const SUPERADMIN_QUERY = gql`
  query SuperadminCompanySwitcher($idCompany: String!) {
    company(id: $idCompany) {
      id
      name
    }
  }
`

export const UPDATE_COMPANY_MUTATION = gql`
  mutation UpdateCompany($id: String!, $name: String!) {
    updateCompany(id: $id, name: $name) {
      id
    }
  }
`

export const CREATE_COMPANY_MUTATION = gql`
  mutation CreateCompany($name: String!) {
    createCompany(name: $name)
  }
`

export const SEARCH_ALL_COMPANIES = gql`
  query SearchCompanies($query: String!, $limit: Int) {
    searchCompany(query: $query, limit: $limit) {
      id
      name
    }
  }
`

export const OBJECT_STORAGE_PROJECT_QUERY = gql`
  query ObjectStorageProjectSwitcher(
    $idCompany: String!
    $idObjectStorage: String!
  ) {
    company(id: $idCompany) {
      id
      objectStorage(id: $idObjectStorage) {
        id
        idProject
      }
    }
  }
`

export const APP_PROJECT_QUERY = gql`
  query AppProjectSwitcher($appName: String!) {
    app(name: $appName) {
      id
      idProject
    }
  }
`

export const DATABASE_PROJECT_QUERY = gql`
  query DatabaseProjectSwitcher($databaseName: String!) {
    database(name: $databaseName) {
      id
      idProject
    }
  }
`

export const PIPELINE_PROJECT_QUERY = gql`
  query PipelineProjectSwitcher($idCompany: String!, $idPipeline: String!) {
    company(id: $idCompany) {
      id
      pipeline(id: $idPipeline) {
        id
        idProject
      }
    }
  }
`

export const STATIC_SITE_PROJECT_QUERY = gql`
  query StaticSiteProjectSwitcher($staticSiteName: String!) {
    staticSite(name: $staticSiteName) {
      id
      idProject
    }
  }
`

export const LOAD_BALANCER_PROJECT_QUERY = gql`
  query LoadBalancerProjectSwitcher(
    $idCompany: String!
    $loadBalancerName: String!
  ) {
    company(id: $idCompany) {
      id
      edgeLoadBalancer(name: $loadBalancerName) {
        id
        idProject
      }
    }
  }
`
